module.exports = __webpack_public_path__ + "static/media/bank.b96740ea.png";